export * from './agris-home-page';
export * from './agris-buscador-page';
export * from './common';
export * from './agris-detalle-insumo-page';
export * from './agris-nueva-cotizacion-page';
export * from './agris-cotizacion-detalle-page';
export * from './agris-lista-cotizaciones-page';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/index.ts